<template>
  <div class="floating-window" :class="{ desktop: $isDesktop }">
    <slot></slot>
  </div>
</template>

<style scoped>
p {
  font-size: var(--body);
}

.floating-window {
  z-index: 1;
  position: fixed;
  margin: var(--edge-margin);
  padding: 1em 1.4em;
  top: 2em;
  left: 0;
  right: 0;
}

.floating-window:before {
  background: rgba(0, 0, 0, 0.5);
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  bottom: 0;
  right: 0;
  pointer-events: all;
}

.floating-window:after {
  background: white;
  content: '';
  width: 100%;
  height: 100%;
  z-index: -1;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: var(--border-radius);
  box-shadow: var(--card-box-shadow);
}

/* desktop & tablet */
.floating-window.desktop {
  margin: auto;
  max-width: 26em;
}
</style>
